import React from 'react';
import StackedPercentageBarChart from '../../charts/StackedPercentageBarChart'
import { useTranslation } from 'react-i18next';
import { useGetDashboardConsentsQuery } from '../../../api/dashboardApiSlice';
import vendorConsentByOsTransformer from '../../../services/data/charts/vendorConsentByOsTransformer';
import BlockChartLoader from '../../BlockChartLoader';

export default function VendorConsentByOs ({filter}) {
  const { t } = useTranslation();
  const defaultData = {"categories":["ios","android"],"series":[{"name":"yes","data":[0,0]},{"name":"no","data":[0,0]}]}
  const { data = [], isSuccess, isLoading, isError, refetch } = useGetDashboardConsentsQuery({filter})
  const chartData = vendorConsentByOsTransformer(data, defaultData)

  return (
    <BlockChartLoader title={t("publisher.vendorConsentByOs")} success={!isLoading && isSuccess} error={!isLoading && isError} retry={refetch}>
      <StackedPercentageBarChart data={chartData}/>
    </BlockChartLoader>
  )
}
